import { useMemo } from "react"
import { Flex, Heading, Image, Text } from "@chakra-ui/react"
import { SUPERSTACK_TOKENS, SupportedTokenName } from "@mezo/sdk"

import superstackDepositIcon from "#/assets/superstack-deposit.svg"
import tbtcTokenLogo from "#/assets/tokens/tbtc-token.svg"

import { getCurrencySymbol } from "../utils"

import CurrencySymbol from "./CurrencySymbol"

type TokenLabelProps = {
  token: SupportedTokenName
  tokenIcon: string
  amount: string | number
  receiptMinted?: bigint
  variant?: "medium" | "large"
  hideTokenName?: boolean
  isMigratedToTbtc?: boolean
}

export default function TokenLabel({
  token,
  tokenIcon,
  amount,
  receiptMinted,
  variant = "medium",
  hideTokenName,
  isMigratedToTbtc,
}: TokenLabelProps) {
  const iconSize = variant === "medium" ? "32px" : "40px"
  const gapSize = variant === "medium" ? "8px" : "16px"

  const showSuperstackIcon = useMemo(
    () =>
      SUPERSTACK_TOKENS.includes(token) &&
      !!receiptMinted &&
      receiptMinted > 0n,
    [receiptMinted, token],
  )

  const displayToken = isMigratedToTbtc ? "tBTC" : token
  const displayTokenIcon = isMigratedToTbtc ? tbtcTokenLogo : tokenIcon

  return (
    <Flex alignItems="center" gap={gapSize}>
      {showSuperstackIcon && (
        <Image src={superstackDepositIcon} objectFit="contain" />
      )}
      <Image
        src={displayTokenIcon}
        h={iconSize}
        w={iconSize}
        objectFit="contain"
      />
      <Flex
        alignItems="flex-end"
        color="primary.black.90"
        fontWeight={500}
        gap={2}
        flexShrink="1"
        minW="1"
      >
        <Heading
          variant="h3"
          fontSize="32px"
          lineHeight="40px"
          overflow="hidden"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          title={`${amount} ${getCurrencySymbol(displayToken)}`}
        >
          {amount}
        </Heading>
        {!hideTokenName && (
          <Text variant="body" pb="3px">
            <CurrencySymbol token={displayToken} />
          </Text>
        )}
      </Flex>
    </Flex>
  )
}
